import script from "./CreateTagPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTagPopup.vue?vue&type=script&setup=true&lang=js"

import "./CreateTagPopup.vue?vue&type=style&index=0&id=9ddfe8e4&lang=css"

const __exports__ = script;

export default __exports__